import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  ActivationEnd,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterEvent,
} from '@angular/router';

import { Observable } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { RestrictIfService } from 'src/app/auth-o3/shared/restrict/restrict-if.service';
import { AuthService } from 'src/app/auth-o3/shared/services/auth.service';
import { NAVBAR_ROUTES } from './navbar.consts';

@Component({
  selector: 'app-navbar',
  templateUrl: './dc-navbar.component.html',
  styleUrls: ['./dc-navbar.component.scss'],
})
export class DcNavbarComponent implements OnInit {
  @Input() user: string;
  @Input() email: string;
  @Input() loggedInAsDistributor: boolean;
  @Input() navigating: boolean;
  @Output() signOutEmitter: EventEmitter<any> = new EventEmitter();
  @Output() loadedEmitter: EventEmitter<any> = new EventEmitter();
  @ViewChild('userMenu') userMenu: ElementRef;
  @ViewChild('toggleButton') toggleButton: ElementRef;

  navItems = NAVBAR_ROUTES;

  public activeRoute: string;
  public userPanelCollapsed: boolean;
  public navbarMenuCollapsed: boolean;

  environment$: Observable<string>;
  loading$: Observable<boolean>;

  constructor(
    router: Router,
    private renderer: Renderer2,
    private authService: AuthService,
    private restricIfService: RestrictIfService
  ) {
    router.events.subscribe((event) => {
      if (event instanceof RouterEvent) {
        this.navigationInterceptor(event);
      }
    });
    this.renderer.listen('window', 'click', (e: Event) => {
      if (
        !this.userMenu.nativeElement.contains(e.target) &&
        !this.toggleButton.nativeElement.contains(e.target)
      ) {
        this.userPanelCollapsed = true;
      }
    });

    this.environment$ = this.authService.getEnvironmentName();
    this.loading$ = this.restricIfService.permissionsLoaded().pipe(
      delay(200),
      tap((loaded) => loaded && this.loadedEmitter.emit())
    );
  }

  ngOnInit(): void {
    this.navbarMenuCollapsed = true;
    this.userPanelCollapsed = true;
  }

  navbarMenuButton(): void {
    this.navbarMenuCollapsed = !this.navbarMenuCollapsed;
    this.userPanelCollapsed = true;
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.navigating = true;
      this.activeRoute = undefined;
      this.navbarMenuCollapsed = true;
      this.userPanelCollapsed = true;
    }
    if (
      event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError
    ) {
      this.navigating = false;
      this.navbarMenuCollapsed = true;
      this.userPanelCollapsed = true;
    }
    if (event instanceof ActivationEnd) {
      this.activeRoute = event.snapshot.routeConfig.path;
      this.navbarMenuCollapsed = true;
      this.userPanelCollapsed = true;
    }
  }

  signOut(): void {
    this.signOutEmitter.emit();
  }
}
